import type { MessageEntity } from "@/indexedDB/types";

/**
 * If a chunked/large-media message is deleted while a recipient is streaming it
 * (watch-while-uploading — e.g. the sender cancelled the upload), stop the
 * service worker's fetch loop for that uploadId. Reuses the SW's UPLOAD_FAILED
 * handler, which breaks the prefetch/in-progress loops and is a no-op if the SW
 * isn't streaming this id.
 *
 * This bridges the message-delete event (which lands in the message/event layer)
 * to the service worker doing the streaming — the delete event alone can't reach
 * it. No-op for non-chunked attachments and messages without media.
 */
export function stopChunkedStreamOnDelete(message: MessageEntity): void {
  const media = message.content.media;
  if (media?.isLargeAttachment && media.attachmentId) {
    navigator.serviceWorker?.controller?.postMessage({
      type: "UPLOAD_FAILED",
      uploadId: media.attachmentId,
    });
  }
}
